<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">春蕾绽放 科技筑梦 ——记2024年春蕾科技女孩项目上海研学营活动</div>
      <div class="news-date">2025年1月7日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news74.webp"/>
          </div>
        </div>
        <p>2024年12月29日至2025年1月1日，中国儿童少年基金会联合腾讯公益慈善基金会，邀请四川省攀枝花市米易县六所初中30名春蕾女孩来到上海，利用四天时间穿梭五大地标，完成了一场探索之旅、科技之旅、成长之旅。</p>
        <p>首次踏足国际大都市上海，首次翱翔蓝天，对大多数春蕾女孩而言，还是首次走出家乡县城。能够汲取更多知识、拓宽视野、结识好友，女孩们对这场研学活动充满期待。</p>
        <div class="news-content-mark">
          <div>1 探秘腾讯展厅 探索AI力量</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_1.webp"/>
          </div>
        </div>
        <p>在腾讯华东总部和优图实验室的支持下，春蕾科技女孩上海研学营第一站来到腾讯公司。在腾讯展厅，孩子们参观了微信星云图、数据中心、腾讯SSV，体验了人工智能桌上冰球、疲劳驾驶预警等，看到了最新的投影技术和灯光效果，女孩们直观感受到了科技带来的乐趣和便捷，对“科技改变生活”有了更深刻地认识。        </p>
        <p>参观后，在腾讯优图算法专家贾老师的讲解中，女孩们认识了什么是AI，渴望能够深入了解AI，更期待有一天能够加入AI探索的队伍。春蕾女孩小玉（化名）表示，聆听讲解让她对AI产生了浓厚兴趣，也萌芽出未来想做一名AI工程师的目标。</p>
        <div class="news-content-mark">
          <div>2 点燃航空梦想 争做强国少年</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_2.png"/>
          </div>
        </div>
        <p>在中国商飞上海飞机制作有限公司某车间，几架C909客机正在紧张有序地组装中。在车间讲解员的讲解下，女孩们近距离目睹了国产大飞机的组装过程，振奋于商用飞机制造的蓬勃发展，更感慨于一路突破创新的艰辛。</p>
        <p>随后，女孩们参观了试飞指挥大厅，女工程师向大家讲述了人类如何实现飞行梦想，以及C919作为国产大飞机如何一步步接近蓝天的不易历程。此次参观不仅让女孩们收获了宝贵的知识，更激发了她们对航空事业的热爱和向往。春蕾女孩小雯（化名）的志向是成为一名飞行员，此行让她更加坚定了自己努力的方向，希望将来能为中国的航空事业贡献力量。</p>
        <div class="news-content-mark">
          <div>3 中国科学院研学之旅 走进干细胞的世界</div>
        </div>
        <p>在深圳新基石科学基金会的支持下，春蕾女孩们走进了中国科学院分子细胞科学卓越创新中心，跟随新基石研究员曾艺研究组团队，度过了一段干细胞的奇妙探索时光。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_3.png"/>
          </div>
        </div>
        <p>在“人工全合成结晶牛胰岛素”展厅，女孩们了解了胰岛素合成的历程，领略了分子细胞卓越中心的科研精神。在研究组特别开设的干细胞科普讲座上，女孩们见证了干细胞研究的累累硕果，争先恐后开展趣味问答。学习完理论知识，女孩们实地参观了实验室，在显微镜下探索细胞世界的奥秘。春蕾女孩小美（化名）眼中闪烁着对未知世界的好奇之光，激动地坦言：“第一次进到实验室，第一次看到会发光的小白鼠，太激动了，干细胞太神奇了，科学的世界真是充满了无限的可能！”</p>
        <div class="news-content-mark">
          <div>4 在交大校园里求索真知 启迪梦想的火焰界</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_4.png"/>
          </div>
        </div>
        <p>冬日的蓝天如洗、暖意融融。作为有着128年历史，跨越了三个世纪历史悠久、声誉卓著的高等学府，上海交通大学吸引着如春蕾女孩们一样对知识充满渴望、对未来无限憧憬的学子。在上海交通大学教育发展基金会副秘书长李毅等的热情接待和陪伴下，女孩们游览校园，驻足华山路校门、盛宅、董浩云航运博物馆、中院、工程馆、饮水思源碑等地点，聆听每座建筑的由来和现况，深入感受这所百年名校的历史与传承，体会到“饮水思源 爱国荣校”八字校训蕴含的丰富内涵。</p>
        <p>游览后，腾讯员工志愿者吴老师为女孩们带来了《互联网职业启蒙与生涯规划》课程讲座，吴老师表示：“从孩子们认真听讲和充满求知的目光中，我真切的感受到她们对于前沿科技及科技发展带来的职业成长机会的浓厚兴趣，希望这场分享可以帮助同学们在成长的道路上开拓视野，树立更加清晰地职业方向。”</p>
        <p>活动结束时，上海交通大学工会妇女委员会副主任郑敏老师为春蕾女孩们赠送了《巾帼交大 科教功勋》一书，寄语女孩们，在未来的道路上要以女性科技前辈们的坚韧与智慧作指引，绽放属于自己的璀璨光彩。</p>
        <div class="news-content-mark">
          <div>5 发现自然之美 领悟自然真谛</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_5.webp"/>
          </div>
        </div>
        <p>上海自然博物馆（上海科技馆分馆）融收藏与研究、展示与教育、文化与休闲、科学与艺术于一体，是国家一级博物馆、上海市重要的科普教育基地和公众社会文化交流平台。</p>
        <p>跨年夜，由上海市科委、上海市教委指导，上海科技馆、腾讯公益慈善基金会主办的“科际穿越·科创校长空间站”科学新年大会暨腾讯科技之夜在上海自然博物馆（上海科技馆分馆）举办。春蕾女孩们在博物馆中探索生命的奥秘，领略“缤纷生命”的多样与奇妙，感受“非洲”风情，观看趣味木偶剧。体验中，女孩们还伴随着座椅的跌落、滚动、倾斜等特效，仿佛穿越时空，沉浸在电影《象之童话》的神奇之中。</p>
        <p>自然博物馆的奇妙之夜，让孩子们增长见识、开拓视野，也在她们心中种下了创新思维和科学梦想。</p>
        <div class="news-content-mark">
          <div>6 仰望天文奇观 感受奥妙宇宙</div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_6.png"/>
          </div>
        </div>
        <p>研学最后一天，女孩们探访了上海天文馆，跟随馆内设有的“家园”、“宇宙”、“征程”三大主题展区以及“中华问天”、“好奇星球”、“航向火星”三个特色区域，揭开了月球成因、地形和探月历程的神秘面纱。</p>
        <p>在“宇宙”展区，借助先进的光学追踪投影仪技术，女孩们得以亲眼目睹星球对周围空间造成的扭曲，直观感受宇宙的奥妙。“征程”展区陈列的火星车、空间站等人类探索宇宙的辉煌成就让女孩们叹为观止。女孩们还近距离观赏1:1还原的天宫一号核心舱，模拟体验航天员在太空中的日常生活，沉浸式感受遨游星辰大海的奇妙之旅。</p>
        <p>4天研学，对春蕾女孩们而言，是一次化茧成蝶的蜕变。随行的带队老师表示：“通过本次研学女孩们结识了好友，增长了知识，拓宽了视野，更加深刻领悟到科技与生活之间的紧密联系，进一步激发了孩子们对科学探索的兴趣，鼓励他们努力学习，立志奋斗拼搏，将来投身于伟大的科技事业之中。”</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/activity/news74/news74_7.webp"/>
          </div>
        </div>
        <p>此次上海研学营，是针对初中女孩开展的首次研学活动，也是春蕾科技女孩新周期项目的重要组成部分。2024年，中国儿童少年基金会、腾讯公益慈善基金会联合启动春蕾科技女孩新周期项目，深化在数字教育与科学教育领域的合作，新周期项目面向初高中阶段的春蕾女孩，计划用三年时间打造初中科技普惠课程+高中研学实践体系化培养模式，开展围绕前沿科技、文化自信等内容的科技营地项目制学习。同时，针对科技方面有潜力及发展志向的女孩，提供全国赛事活动参与、与优秀女性科技工作者交流共创等机会，不断提升女孩科技素养与数字技能，引领她们在科技领域更长远的发展。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News74.vue